import axios from "axios";

export const read = async (skip,query, searchThis,user) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listInquiryNewEmpty?skip=${skip}&user=${user}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}